import type { NotificationTriggerType } from '@cims-online/shared'
import CIMSFormItem from 'components/CIMSFormItem'
import CIMSSelect from 'components/CIMSSelect'
import type {
  NotificationField,
  NotificationStatus,
} from '../../../../../types'
import { useFieldOptions } from '../../../hooks/useFieldOptions'
import FieldChangeSettingsField from './FieldChangeSettingsField'
import TransitionSettings from './TransitionSettings'

type TriggerTypeSettingsProps = {
  fields: NotificationField[]
  statuses: NotificationStatus[]
  trigger: NotificationTriggerType
}

function TriggerTypeSettings({
  fields,
  statuses,
  trigger,
}: TriggerTypeSettingsProps) {
  const approvalFieldOptions = useFieldOptions(fields, 'approvals')

  switch (trigger) {
    case 'row_edited':
      return (
        <FieldChangeSettingsField fields={fields} name={['drafts', trigger]} />
      )
    case 'advanced':
    case 'reverted':
      return (
        <TransitionSettings
          fields={fields}
          statuses={statuses}
          trigger={trigger}
        />
      )
    case 'option_state_changed':
      return (
        <CIMSFormItem
          label="Approvals Field"
          name={['drafts', trigger, 'field']}
          requiredMessage="Please select an approvals field"
        >
          <CIMSSelect
            options={approvalFieldOptions}
            placeholder="Select an approvals field"
          />
        </CIMSFormItem>
      )
    case 'row_comments_changed':
    case 'removed':
    case 'restored':
      return null
  }
}

export default TriggerTypeSettings
